module.exports = __webpack_public_path__ + "static/securityandservice-b3fb38553f084fdcecdb37ee75ed0e30.png";